import { DraftCalendarIcon } from '@/components/shared/icons/AddCalendarIcon';
import { AutoFillLoader } from '@/components/shared/icons/AutoFillLoader';
import { CreateCalendarIcon } from '@/components/shared/icons/CreateCalendarIcon';
import { PublishedCalendarIcon } from '@/components/shared/icons/PublishedCalendarIcon';
import { isDateInPast } from '@/helpers/dateHelper';
import { merge } from '@/helpers/Utility';
import { FC, JSX } from 'react';
import strings from '../roster.translations';
import { RosterStatus } from '../roster.types';
import { isRosterPublished } from '../rosterHelper';
import { RosterCalendarContextObject } from './useRosterCalendarEvents';

interface IconToDisplayProps {
  contextObject?: RosterCalendarContextObject;
  date: Date;
}

export const IconToDisplay: FC<IconToDisplayProps> = ({ contextObject, date }) => {
  let text: string = '';
  let icon: JSX.Element = <div></div>;

  const inPast = isDateInPast(date, new Date());

  if (contextObject?.rosterStatus === RosterStatus.optimising) {
    icon = <AutoFillLoader />;
    text = strings.autofill;
  } else if (!contextObject?.id) {
    if (!inPast) {
      icon = <CreateCalendarIcon />;
      text = strings.create;
    }
  } else if (isRosterPublished(contextObject.rosterStatus as RosterStatus)) {
    icon = <PublishedCalendarIcon />;
    text = inPast ? strings.completed : strings.published;
  } else if (contextObject.id) {
    icon = <DraftCalendarIcon />;
    text = strings.draft;
  }

  return (
    <div className={merge('flex flex-col items-center text-gray-500')}>
      {icon}
      <p className="text-xs font-bold">{text.toUpperCase()}</p>
    </div>
  );
};
